import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import type { ComparisonImage, ComparisonSelection, ImageInspection, SlotIndex } from './types';
const useComparison = (images, initialSelection) => {
  const $ = _c(24);
  let t0;
  if ($[0] !== images || $[1] !== initialSelection) {
    t0 = () => initialSelection ?? [images[0]?.id ?? null, images[1]?.id ?? null];
    $[0] = images;
    $[1] = initialSelection;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const [selection, setSelection] = useState(t0);
  const [activeSlot, setActiveSlot] = useState(1);
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const [views, setViews] = useState(t1);
  let t2;
  if ($[4] !== images || $[5] !== selection) {
    let t3;
    if ($[7] !== images) {
      t3 = id => images.find(image => image.id === id);
      $[7] = images;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = selection.map(t3);
    $[4] = images;
    $[5] = selection;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const slots = t2;
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setViews({});
    };
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const dismiss = t3;
  let t4;
  if ($[10] !== activeSlot || $[11] !== images) {
    t4 = (id_0, t5) => {
      const slot = t5 === undefined ? activeSlot : t5;
      if (!images.some(image_0 => image_0.id === id_0)) {
        return;
      }
      setSelection(current => {
        const next = [...current];
        const other = slot === 0 ? 1 : 0;
        if (current[other] === id_0) {
          next[other] = current[slot];
        }
        next[slot] = id_0;
        return next;
      });
      setActiveSlot(slot);
      dismiss();
    };
    $[10] = activeSlot;
    $[11] = images;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const selectImage = t4;
  let t5;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = slot_0 => {
      setSelection(current_0 => slot_0 === 0 ? [null, current_0[1]] : [current_0[0], null]);
      setActiveSlot(slot_0);
      dismiss();
    };
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const clearSlot = t5;
  let t6;
  if ($[14] !== views) {
    t6 = (id_1, point) => {
      setViews(views[id_1] ? {} : {
        [id_1]: point
      });
    };
    $[14] = views;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const inspectImage = t6;
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = (id_2, point_0) => setViews(current_1 => ({
      ...current_1,
      [id_2]: point_0
    }));
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const pan = t7;
  let t8;
  if ($[17] !== activeSlot || $[18] !== inspectImage || $[19] !== selectImage || $[20] !== selection || $[21] !== slots || $[22] !== views) {
    t8 = {
      slots,
      selection,
      activeSlot,
      setActiveSlot,
      selectImage,
      clearSlot,
      views,
      inspectImage,
      pan,
      dismiss
    };
    $[17] = activeSlot;
    $[18] = inspectImage;
    $[19] = selectImage;
    $[20] = selection;
    $[21] = slots;
    $[22] = views;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};
export default useComparison;